
  (function () {
    var root = document.querySelector('[data-bc-pdp="main"]');
    if (!root) return;
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-bc-variants]').textContent); } catch (e) {}
    var form = document.getElementById('BcProductForm-main');
    var idInput = root.querySelector('[data-bc-variant-id]');
    var qty = document.getElementById('BcQty-main');
    var duo = root.querySelector('[data-bc-duo]');
    var slider = document.getElementById('BcSlider-main');
    var addLabel = "Ajouter au panier";
    var money = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: "EUR" });
    var current = variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0];

    function format(cents) { return money.format(cents / 100); }

    function updateTotal() {
      var q = Math.max(1, parseInt(qty.value, 10) || 1);
      var total = root.querySelector('[data-bc-total]');
      if (current && q > 1) {
        root.querySelector('[data-bc-total-value]').textContent = format(current.price * q) + ' pour ' + q + ' bouillottes';
        total.hidden = false;
      } else {
        total.hidden = true;
      }
      if (duo) duo.setAttribute('aria-pressed', String(q === 2));
    }

    function showMedia(id) {
      var slide = document.getElementById('BcSlide-main-' + id);
      if (slide && slider) slider.scrollTo({ left: slide.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
    }

    function onOptionChange() {
      var picked = [];
      root.querySelectorAll('[data-bc-option]:checked').forEach(function (input) {
        picked[parseInt(input.getAttribute('data-bc-option'), 10)] = input.value;
        var label = root.querySelector('[data-bc-option-label="' + input.getAttribute('data-bc-option') + '"]');
        if (label) label.textContent = input.value;
      });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === picked[i]; });
      });
      var buttons = root.querySelectorAll('[data-bc-add]');
      if (!match) {
        buttons.forEach(function (b) { b.disabled = true; b.querySelector('[data-bc-add-label]').textContent = 'Indisponible'; });
        return;
      }
      current = match;
      idInput.value = match.id;
      root.querySelectorAll('[data-bc-price]').forEach(function (el) { el.textContent = format(match.price); });
      buttons.forEach(function (b, i) {
        b.disabled = !match.available;
        b.querySelector('[data-bc-add-label]').textContent = match.available ? (b.closest('[data-bc-sticky]') ? 'Ajouter' : addLabel) : 'Épuisé';
      });
      if (match.featured_media) showMedia(match.featured_media.id);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
      updateTotal();
    }

    root.querySelectorAll('[data-bc-option]').forEach(function (input) { input.addEventListener('change', onOptionChange); });

    root.querySelectorAll('[data-bc-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = (parseInt(qty.value, 10) || 1) + parseInt(btn.getAttribute('data-bc-qty'), 10);
        qty.value = Math.min(20, Math.max(1, q));
        updateTotal();
      });
    });
    qty.addEventListener('change', updateTotal);
    if (duo) duo.addEventListener('click', function () {
      qty.value = duo.getAttribute('aria-pressed') === 'true' ? 1 : 2;
      updateTotal();
    });

    if (form) form.addEventListener('submit', function () {
      root.querySelectorAll('[data-bc-add]').forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    });

    /* Galerie : vignettes et compteur */
    if (slider) {
      root.querySelectorAll('[data-bc-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () { showMedia(thumb.getAttribute('data-bc-thumb')); });
      });
      if ('IntersectionObserver' in window) {
        var slides = slider.querySelectorAll('.bc-pdp__slide');
        var counter = root.querySelector('[data-bc-counter]');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var index = Array.prototype.indexOf.call(slides, entry.target);
            if (counter) counter.textContent = index + 1;
            root.querySelectorAll('[data-bc-thumb]').forEach(function (t) {
              t.setAttribute('aria-current', String(t.getAttribute('data-bc-thumb') === entry.target.getAttribute('data-media-id')));
            });
          });
        }, { root: slider, threshold: 0.6 });
        slides.forEach(function (s) { io.observe(s); });
      }
    }

    /* Date de livraison estimée (jours ouvrés, hors week-ends) */
    var eta = root.querySelector('[data-bc-eta]');
    if (eta) {
      var addBusinessDays = function (date, days) {
        var d = new Date(date);
        while (days > 0) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) days--;
        }
        return d;
      };
      var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' });
      var now = new Date();
      var min = addBusinessDays(now, parseInt(eta.getAttribute('data-min'), 10));
      var max = addBusinessDays(now, parseInt(eta.getAttribute('data-max'), 10));
      eta.querySelector('[data-bc-eta-text]').innerHTML = 'Livraison offerte, estimée entre le <strong>' + fmt.format(min) + '</strong> et le <strong>' + fmt.format(max) + '</strong>.';
    }

    /* Barre d'achat fixe : visible quand le bouton principal sort de l'écran */
    var sticky = root.querySelector('[data-bc-sticky]');
    var mainAdd = root.querySelector('.bc-pdp__buttons [data-bc-add]');
    if (sticky && mainAdd && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.shopify-section-group-footer-group, footer');
      var addVisible = true;
      var footerVisible = false;
      var update = function () {
        var below = mainAdd.getBoundingClientRect().top > window.innerHeight;
        sticky.classList.toggle('is-visible', !addVisible && !footerVisible && !below);
      };
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === mainAdd) addVisible = entry.isIntersecting;
          else footerVisible = entry.isIntersecting;
        });
        update();
      });
      obs.observe(mainAdd);
      if (footer) obs.observe(footer);
    }

    updateTotal();
  })();


  (function () {
    var root = document.querySelector('[data-bc-videos="videos"]');
    if (!root) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    var auto = !reduce && !saveData;

    root.querySelectorAll('[data-bc-video-card]').forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;
      var bar = card.querySelector('[data-bc-progress]');
      var sound = card.querySelector('[data-bc-sound]');
      var userPaused = false;

      function play() {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      function toggle() {
        if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); }
      }

      video.addEventListener('playing', function () { card.classList.add('is-playing'); });
      video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
      video.addEventListener('timeupdate', function () {
        if (bar && video.duration) bar.style.transform = 'scaleX(' + (video.currentTime / video.duration) + ')';
      });
      card.addEventListener('click', function (event) {
        if (event.target.closest('[data-bc-sound]')) return;
        toggle();
      });
      sound.addEventListener('click', function () {
        video.muted = !video.muted;
        sound.setAttribute('aria-pressed', String(!video.muted));
        sound.setAttribute('aria-label', video.muted ? 'Activer le son' : 'Couper le son');
        if (video.paused) { userPaused = false; play(); }
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              if (auto && !userPaused) play();
            } else if (!video.paused) {
              video.pause();
            }
          });
        }, { threshold: [0, 0.6] }).observe(card);
      }
    });
  })();


    (function () {
      var root = document.querySelector('[data-bc-reveal-root="faq"]');
      if (!root || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('bc-reveal-on');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      root.querySelectorAll('[data-bc-reveal]').forEach(function (el) { io.observe(el); });
    })();
  

    (function () {
      var root = document.querySelector('[data-bc-reveal-root="safety"]');
      if (!root || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('bc-reveal-on');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      root.querySelectorAll('[data-bc-reveal]').forEach(function (el) { io.observe(el); });
    })();
  